<template>
    <div>
        <MainLayout>
            <h1>{{ $t('file_title') }}</h1>
            <form>
                <input ref="file" v-on:change="upload" type="file">
                <textarea v-model="new_file.description" :placeholder="$t('general_description')"/>
                <button v-on:click="addFiles" :disabled="loading">
                    <img class="file_upload_loader" src="../assets/loader.gif" v-if="loading">
                    {{ $t('general_add') }}
                </button>
            </form>
            <table class="table">
                <thead>
                <tr>
                    <th>{{ $t('general_id') }}</th>
                    <th>{{ $t('general_name') }}</th>
                    <th>{{ $t('general_description') }}</th>
                    <th>{{ $t('general_option') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(file,index) in files" v-bind:key="index">
                    <td>{{ file.id }}</td>
                    <td v-on:dblclick="goToEdit(file.id,true)">
                        <a :href="download+file.id" v-if="edit[file.id]!==true">{{ file.filename }}</a>
                        <input v-on:blur="editFile(file.id,file)" :ref="'input_edit_'+file.id" v-else-if="edit[file.id]===true" v-model="file.filename">
                    </td>
                    <td v-on:dblclick="goToEdit(file.id,true)">
                        <span class="nl2br" v-if="edit[file.id]!==true">{{ file.description }}</span>
                        <textarea v-on:blur="editFile(file.id,file)" :ref="'input_edit_'+file.id" v-else-if="edit[file.id]===true" v-model="file.description"/>
                    </td>
                    <td>
                        <button v-on:click="goToEdit(file.id,true)">{{ $t('general_edit') }}</button>
                        <button v-on:click="deleteFile(file.id)">{{ $t('general_delete') }}</button>
                    </td>
                </tr>
                </tbody>

                <div class="pagination">
                    <Pagination route_name="file_list" :page="page" :on_page="on_page" :total_item="total_item"/>
                </div>
            </table>
        </MainLayout>
    </div>
</template>

<script>
    import MainLayout from '../components/MainLayout.vue';
    import Pagination from '../components/Pagination';
    import {bus} from '../main'
    import config from '../config'

    export default {
        name: "FileList",
        components: {
            MainLayout,
            Pagination,
        },
        data:function(){
            return {
                files:[],
                new_file:{},
                loading:false,
                download:config.API_URL+'files/download/',
                edit:[],
                on_page:15,
                total_item:0,
                page:1,
            }
        },
        methods: {
            loadFiles: function() {
                let offset=((this.on_page * this.page)-this.on_page);
                this.axios.get(config.API_URL+'files?offset='+offset+'&limit='+this.on_page).then(response => {
                    this.files = response.data.data;
                    this.total_item = parseInt(response.data.total);
                }).catch(error => {
                    if(error.response.status===401){
                        bus.$emit('logout',true);
                    }else{
                        bus.$emit('alert-error',error.response.data.message);
                    }
                });
            },
            addFiles(){
                this.axios.post(config.API_URL+'files',new URLSearchParams(
                    this.new_file
                )).then(response => {
                    this.new_file.filename = '';
                    this.new_file.filecontent = '';
                    this.new_file.description = '';
                    this.$refs.file.value = null;
                    this.loadFiles();
                    bus.$emit('alert-success',response.data.message);
                }).catch(error => {
                    if(error.response.status===401){
                        bus.$emit('logout',true);
                    }else{
                        bus.$emit('alert-error',error.response.data.message);
                    }
                });
            },
            goToEdit(id){
                this.edit[id]=true;
                this.$forceUpdate();
            },
            editFile(id , file){
                this.axios.put(config.API_URL+'files/'+id, new URLSearchParams(
                    file
                )).then(response => {
                    this.edit[id]=false;
                    this.$forceUpdate();
                    bus.$emit('alert-success',response.data.message);
                }).catch(error => {
                    if(error.response.status===401){
                        bus.$emit('logout',true);
                    }else{
                        bus.$emit('alert-error',error.response.data.message);
                    }
                });
            },
            deleteFile:function(id){
                if(confirm(this.$t('general_delete_question'))) {
                    this.axios.delete(config.API_URL + 'files/' + id).then(response => {
                        this.loadFiles();
                        bus.$emit('alert-success', response.data.message);
                    }).catch(error => {
                        if (error.response.status === 401) {
                            bus.$emit('logout', true);
                        } else {
                            bus.$emit('alert-error', error.response.data.message);
                        }
                    });
                }
            },
            upload(){
                let file = this.$refs.file;
                let reader = new FileReader();
                let vm = this;
                this.loading = true;
                reader.onload = function (e) {
                    vm.new_file.filename = file.files[0].name;
                    vm.new_file.filecontent = e.target.result;
                    vm.loading = false;
                };
                reader.readAsDataURL(file.files[0]);
            },
        },
        mounted() {
            if(this.$route.params.page) this.page = parseInt(this.$route.params.page); else this.page = 1;
            this.loadFiles();
        },
        beforeRouteUpdate(to,from,next){
            if(to.params.page) this.page = parseInt(to.params.page); else this.page = 1;
            this.loadFiles();
            next();
        },
    }
</script>

<style scoped>
    .file_upload_loader{
        width: 15px;
        height: 15px;
    }
    .table{
        width: 100%;
    }
    .table th{
        text-align: left;
    }
    .table tr:hover{
        background-color: lightgray;
    }
</style>
